// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__2Xid_","links":"Footer_links__1rjOC","outLinks":"Footer_outLinks__Iwr6d","info":"Footer_info__153TN"};